import React, { useEffect, useMemo } from 'react';
import { SingleCommonType } from '../../types';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import { commonBackInfo } from '../../utils';
import {
  genreGameLocale,
  genreGameRadioOptions,
  genreSplitFlag,
} from '../../constants/genreGame';
import useDefaultTwoLevelFilter from '../../hooks/useDefaultTwoLevelFilter';
import { useIntl } from 'umi';
import { addFilterBuriedPoint } from '../../utils/point';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function GenreSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  filterOptions,
  beginWatch = false,
  languageTitle = genreGameLocale,
}: SingleCommonType & {
  unlabeledReviewsValue?: string;
  beginWatch?: boolean;
  languageTitle?: any;
}) {
  const genreGameOptions: any = useMemo(() => {
    let realFilterOptions: any = [];
    if (filterOptions?.length > 0) {
      realFilterOptions = filterOptions.map(
        ({ genre, genre_cn, sub_genre }: any) => {
          let key = genre?.toLocaleLowerCase?.();
          return {
            value: key,
            text: genre,
            textCN: genre_cn,
            children: (sub_genre || [])
              .filter((item: any) => item.genre)
              .map(({ genre, genre_cn }: any) => {
                let key1 = genre?.toLocaleLowerCase?.();
                return {
                  value: key + genreSplitFlag + key1,
                  text: genre || 'Unknown',
                  textCN: genre_cn || '未知',
                };
              }),
          };
        },
      );
    }
    realFilterOptions.sort((a, b) => a.value.localeCompare(b.value));
    realFilterOptions.push({
      value: 'others',
      text: 'Others',
      textCN: '其他',
      children: [
        {
          value: 'others' + genreSplitFlag + 'others',
          text: 'Others',
          textCN: '其他',
        },
      ],
    });
    return realFilterOptions;
  }, [filterOptions]);

  const {
    setSelectValue,
    selectValue,
    onChange: onGenreChange,
    diffClassName,
  } = useDefaultTwoLevelFilter({
    originalOptions: genreGameOptions,
    defaultValue,
    filterValue,
    beginWatch,
    onlySecondLevelValue: true,
    watchOptionsSetDefaultValue: true,
    dealwithDefaultValue: (value) => {
      let genre = value?.genreGame || [];
      return { value: genre, type: 'market' };
    },
  });

  const genreChange = (tags: any) => {
    setSelectValue(tags);
  };
  const { formatMessage } = useIntl();
  useEffect(() => {
    let { value } = onGenreChange(selectValue);
    onChange?.(
      'genreGame',
      commonBackInfo(
        { genreGame: value },
        { genreGame: value.length === 0 ? 'All' : value.length },
      ),
    );
  }, [selectValue, formatMessage]);

  return (
    <div className={`genre-game-select-wrapper ${diffClassName}`}>
      <NewRegionSelect
        value={selectValue}
        options={genreGameOptions}
        locale={lang}
        language={languageTitle}
        radioOptions={genreGameRadioOptions}
        closeOnScroll={true}
        radioOptionsTips={{
          global: lang === 'en-US' ? 'No result found' : '无匹配项',
        }}
        onCloseReginSelect={(result: any) => {
          genreChange(result);

          try {
            let { value } = onGenreChange(result);
            addFilterBuriedPoint(
              FilterButtonPoint.genre,
              value.length === 0 ? 'All' : value,
            );
          } catch (error) {}
        }}
      ></NewRegionSelect>
    </div>
  );
}
